export enum DigitalFormFieldTypeEnum {
    TEXTO = 'TEXTO',
    CAIXA_TEXTO = 'CAIXA_TEXTO',
    NUMERICO = 'NUMERICO',
    DATA = 'DATA',
    SELECAO = 'SELECAO',
    /** CPF ou CNPJ (o nome ficou do primeiro modelo): a máscara muda pelo tamanho. */
    CPF = 'CPF',
    RG = 'RG',
}

export interface IDigitalFormFieldTypeOption {
    value: DigitalFormFieldTypeEnum;
    label: string;
    icon: string;
    hint: string;
}

/** Ordem de exibição no seletor de tipo, do mais usado para o menos usado. */
export const DIGITAL_FORM_FIELD_TYPES: IDigitalFormFieldTypeOption[] = [
    {
        value: DigitalFormFieldTypeEnum.TEXTO,
        label: 'Texto',
        icon: 'ph ph-text-aa',
        hint: 'Linha única, para nomes e identificações curtas.',
    },
    {
        value: DigitalFormFieldTypeEnum.CAIXA_TEXTO,
        label: 'Caixa de texto',
        icon: 'ph ph-text-align-left',
        hint: 'Várias linhas, para descrições e justificativas.',
    },
    {
        value: DigitalFormFieldTypeEnum.NUMERICO,
        label: 'Numérico',
        icon: 'ph ph-hash',
        hint: 'Aceita apenas números.',
    },
    {
        value: DigitalFormFieldTypeEnum.DATA,
        label: 'Data',
        icon: 'ph ph-calendar-blank',
        hint: 'Seletor de data no formato dd/mm/aaaa.',
    },
    {
        value: DigitalFormFieldTypeEnum.SELECAO,
        label: 'Seleção',
        icon: 'ph ph-list-checks',
        hint: 'Lista de opções definidas por você.',
    },
    {
        value: DigitalFormFieldTypeEnum.CPF,
        label: 'CPF/CNPJ',
        icon: 'ph ph-identification-card',
        hint: 'CPF ou CNPJ: a máscara se ajusta ao que for digitado, com os dígitos conferidos.',
    },
    {
        value: DigitalFormFieldTypeEnum.RG,
        label: 'RG',
        icon: 'ph ph-identification-badge',
        hint: 'Números e letras, com ponto, hífen ou barra, como no documento.',
    },
];

/** Largura do campo na tela do cidadão. */
export enum DigitalFormFieldWidthEnum {
    PEQUENO = 'PEQUENO',
    MEDIO = 'MEDIO',
    GRANDE = 'GRANDE',
}

export interface IDigitalFormFieldWidthOption {
    value: DigitalFormFieldWidthEnum;
    label: string;
    hint: string;
}

export const DIGITAL_FORM_FIELD_WIDTHS: IDigitalFormFieldWidthOption[] = [
    { value: DigitalFormFieldWidthEnum.PEQUENO, label: 'Pequeno', hint: 'Um quarto da linha: datas, números e códigos' },
    { value: DigitalFormFieldWidthEnum.MEDIO, label: 'Médio', hint: 'Metade da linha: nomes e seleções' },
    { value: DigitalFormFieldWidthEnum.GRANDE, label: 'Inteiro', hint: 'Ocupa a linha inteira' },
];

/** Largura sugerida pelo tipo, usada enquanto o administrador não escolhe outra. */
export function defaultFieldWidth(tipo: DigitalFormFieldTypeEnum): DigitalFormFieldWidthEnum {
    switch (tipo) {
        case DigitalFormFieldTypeEnum.DATA:
        case DigitalFormFieldTypeEnum.NUMERICO:
        case DigitalFormFieldTypeEnum.CPF:
        case DigitalFormFieldTypeEnum.RG:
            return DigitalFormFieldWidthEnum.PEQUENO;
        case DigitalFormFieldTypeEnum.CAIXA_TEXTO:
            return DigitalFormFieldWidthEnum.GRANDE;
        default:
            return DigitalFormFieldWidthEnum.MEDIO;
    }
}

/** Limite de caracteres da resposta. O backend valida os mesmos valores. */
export const DIGITAL_FORM_FIELD_MAX_LENGTH: Partial<Record<DigitalFormFieldTypeEnum, number>> = {
    [DigitalFormFieldTypeEnum.TEXTO]: 250,
    [DigitalFormFieldTypeEnum.CAIXA_TEXTO]: 5000,
    [DigitalFormFieldTypeEnum.RG]: 20,
};

export enum DigitalFormSignatureStatusEnum {
    NAO_REQUER = 'NAO_REQUER',
    /** Exige o responsável; a triagem ainda precisa analisar e encaminhar. */
    AGUARDANDO_TRIAGEM = 'AGUARDANDO_TRIAGEM',
    /** Encaminhado pela triagem, na fila de Assinaturas Pendentes. */
    AGUARDANDO_RESPONSAVEL = 'AGUARDANDO_RESPONSAVEL',
    ASSINADO = 'ASSINADO',
    /** A solicitação foi anulada antes da assinatura do responsável. */
    ANULADO = 'ANULADO',
}
